module.exports = __webpack_public_path__ + "static/home-page-3ebf070a91235db1a53ea04e1467eb39.png";